import React from 'react'
import PricingTab from '../../../core/components/pricingTab/page'

const CmsPricing = () => {
  return (
    <>
      <div className='pricingPage'>
        {/* Page Content */}
        <div className="content">
          {/* Featured Plans */}
          <section className="featured-plan">
            <div className="container">
              <div className="section-heading">
                <h1>Affordable Pricing</h1>
                <p className="sub-title">
                  Get started with a 7 days free trial. <br /> Choose the plan that best fits your business needs.
                </p>
              </div>
              <PricingTab />
            </div>
          </section>
          {/* /Featured Plans */}
        </div>
        {/* /Page Content */}
      </div>
    </>
  )
}

export default CmsPricing